"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ZillowMapContext is used by ZillowMapControl originally to make the google map instance
// available to child components and grandchild components.
// It has been expanded to allow additional context information passed to assit with performance
// this should NOT be used by page specific features as being able to switch off of
// google is some day expected, using this interface will break your page if that
// happens.
var ZillowMapContext = _react.default.createContext({} // Defaulting to an empty object so consumers don't have to null check both the object and the value of it they are interested in.
);

var _default = ZillowMapContext;
exports.default = _default;